export default {
  userList: '成員列表',
  account: '帳號',
  role: '權限種類',
  status: '狀態',
  inviting: '邀請中',
  disabled: '已停用',
  activating: '啟用中',
  roleList: '權限種類',
  userInvite: {
    title: '邀請人員',
    form: {
      email: {
        feedback: {
          invalid: 'Email格式不正確',
          required: '請輸入Email'
        }
      },
      role: {
        label: '權限種類',
        placeholder: '請選擇權限種類',
        feedback: {
          required: '請選擇權限種類'
        }
      },
      send: '傳送',
      sendFailed: '傳送失敗',
      sendSucceed: '傳送成功'
    }
  },
  userSetting: {
    personalInfo: '個人資訊',
    confirmDelete: '確認刪除?',
    form: {
      name: '姓名',
      mobile: '手機',
      roles: '權限種類',
      saveFailed: '保存失敗',
      saveSucceed: '保存成功'
    },
    deleteSucceed: '刪除成功'
  },

  // 權限種類
  roleColumn: {
    name: '權限種類',
    desc: '描述',
    userCount: '人數',
    creater: '建立者',
    updater: '更新者'
  },
  roleEdit: {
    title: '權限種類管理',
    userCount: '成員數',
    creater: '建立者',
    updater: '更新者',
    authority: '權限',

    editRoleName: '權限種類名稱',
    editRoleDesc: '編輯敘述',
    editParentRole: '選擇父層權限種類',

    disableDelete: '無法刪除',
    confirmDelete: '確認刪除?',
    confirmDrop: '確認捨棄?',

    pleaseInput: '請輸入',
    overWordLimit: '超過字數上限',

    feature: '功能',
    permissionDesc: {
      edit: {
        label: '「編輯」',
        desc: '含功能內的新增、編輯、儲存和複製；'
      },
      publish: {
        label: '「發佈」',
        desc: '含功能內的發佈、發送、建立、啟用和上下架'
      },
      viewType: {
        label: '「資料觀看」',
        desc: '預設可觀看該功能所有資料；若選同權限種類，則僅能觀看同權限種類設定的資料'
      }
    },
    viewType: {
      label: '資料觀看',
      option: {
        nolimit: '不限制',
        sameRole: '同權限種類'
      }
    },
    permission: {
      edit: '編輯',
      publish: '發佈',
      delete: '刪除',
      export: '匯出',
      import: '匯入',
      reject: '駁回'
    }
  }
};
